// extracted by mini-css-extract-plugin
module.exports = {"Form":"SignupForm_Form__1LDKs","Alt":"SignupForm_Alt__1DBVw","DropDown":"SignupForm_DropDown__2Qfm-"};